import { lessonList } from "constants/lesson";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addLesson = async (bodyData) => {
  try {
    const res = await api.add_lesson(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

export const updateLessonById = async (id, bodyData) => {
  try {
    const res = await api.update_lesson_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getLessonsByCourseId = async (id, dispatch, pageNum, filters) => {
  try {
    const res = await api.get_lessons_by_course_id(id, pageNum, filters);
    dispatch({ type: lessonList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: lessonList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error?.response?.data);
  }
};

export const getLessonById = async (id) => {
  try {
    const res = await api.get_lesson_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteLesson = async (id) => {
  try {
    const res = await api.delete_lesson(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};